<template>
	<div>
		<common-tooltip class="setting-label" tagName="p">
			<template v-slot:tooltip>Manually insert your campaign or configure and display it automatically. Advanced output settings are still in effect.</template>
			<span>How should your inline campaign be displayed?</span>
		</common-tooltip>

		<common-selectable-group
			wrapTag="p"
			groupName="settingAutomatic"
			:options="[
				{
					label: 'Manual',
					value: '0',
					help: 'Insert the campaign manually in your post or page.',
					checked: ! isAuto
				},
				{
					label: 'Automatic',
					value: '1',
					help: 'Configure and display your campaign automatically.',
					checked: isAuto
				},
			]"
			@input="setValue"
		/>

		<div
			v-if="isAuto"
			class="omapi-radio-group omapi-radio-group__indent omapi-radio-group__with-inputs omapi-input"
		>
			<common-selectable-input
				value="words"
				name="settingAutoLocation"
				@input="setCompooundValue($event, $refs.afterWords, 300)"
				:checked="'words' === settingAutoLocation"
			>
				After
				<input
					class="omapi-input omapi-input__inline"
					name="settingAutoLocationWords"
					v-model.number="settingAutoLocationWords"
					type="number"
					min="1"
					width="4"
					style="flex-basis: 54px;"
					ref="afterWords"
				/>
				Words
			</common-selectable-input>
			<common-selectable-input
				value="paragraphs"
				name="settingAutoLocation"
				@input="setCompooundValue($event, $refs.afterParagraphs, 3)"
				:checked="'paragraphs' === settingAutoLocation"
			>
				After
				<input
					class="omapi-input omapi-input__inline"
					name="settingAutoLocationParagraphs"
					v-model.number="settingAutoLocationParagraphs"
					type="number"
					min="1"
					width="4"
					style="flex-basis: 54px;"
					ref="afterParagraphs"
				/>
				Paragraphs
			</common-selectable-input>
			<common-selectable-input
				label="Below Post"
				value="below_post"
				name="settingAutoLocation"
				@input="setValue"
				:checked="'below_post' === settingAutoLocation || ! settingAutoLocation"
			/>
			<common-selectable-input
				label="Above Post"
				value="above_post"
				name="settingAutoLocation"
				@input="setValue"
				:checked="'above_post' === settingAutoLocation"
			/>
		</div>

		<campaigns-shortcode-box
			v-if="! isAuto"
			:campaignSlug="id"
		/>
	</div>
</template>

<script lang="js">
import { campaign } from '@/campaigns/mixins/campaign'

export default  {
	mixins : [ campaign ],
	props  : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		isAuto () {
			return '1' === this.settingAutomatic
		},
	},
}
</script>
